export default [
  /*Gestión Comercial y Clientes*/
  {
    component: 'CNavTitle',
    name: 'Gestión Comercial y Clientes',
    to: '/vehicles',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Vehículos',
    to: '/vehicles',
    icon: 'cil-car-alt',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Vehículos',
    to: '/vehicles/user',
    icon: 'cil-car-alt',
    require_admin: false,
    show_admin: false,
  },
  {
    component: 'CNavItem',
    name: 'Formas de compras',
    to: '/purchase_method',
    icon: 'cil-wallet',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Partner',
    to: '/associates',
    icon: 'cil-people',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Gastos adicionales',
    to: '/additional_expenses',
    icon: 'cil-cash',
    require_admin: true,
    show_admin: true,
  },

  {
    component: 'CNavItem',
    name: 'Productividad',
    to: '/productivity',
    icon: 'cil-credit-card',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Bancos',
    to: '/banks',
    icon: 'cil-bank',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Clientes',
    to: '/customer',
    icon: 'cil-user',
    require_admin: true,
    show_admin: true,
  },

  /*Gestión Administrativa*/
  {
    component: 'CNavTitle',
    name: 'Gestión Administrativa',
    to: '/vehicles',
    require_admin: true,
    show_admin: true,
  },
    {
    component: 'CNavItem',
    name: 'Canales',
    to: '/channels',
    icon: 'cil-line-weight',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Origen',
    to: '/origin',
    icon: 'cil-bookmark',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Combustible',
    to: '/fuel',
    icon: 'cil-industry',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Ubicación',
    icon: 'cil-location-pin',
    to: '/location',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Transporte',
    to: '/transport',
    icon: 'cil-truck',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Estados',
    to: '/conditions',
    icon: 'cil-tag',
    require_admin: true,
    show_admin: true,
  },

  {
    component: 'CNavGroup',
    name: 'Reportes de Ventas',
    to: '/debts_statistics',
    icon: 'cil-chart',
    require_admin: true,
    show_admin: true,
    items: [
      {
        component: 'CNavItem',
        name: 'Deudas por Usuario',
        to: '/debts_statistics',
        icon: 'cil-chart-pie'
      },
      {
        component: 'CNavItem',
        name: 'Ventas por Usuario',
        to: '/general_sale_statistics',
        icon: 'cil-chart-pie'
      },
      {
        component: 'CNavItem',
        name: 'Gráfico Mensual',
        to: '/monthly_graph',
        icon: 'cil-chart-pie'
      },
      {
        component: 'CNavItem',
        name: 'Objetivo de ventas',
        to: '/goals',
        icon: 'cil-chart-pie',
        require_admin: true,
        show_admin: true
      }
    ]
  },
  {
    component: 'CNavItem',
    name: 'Financiera',
    to: '/financial',
    icon: 'cil-diamond',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Comerciales',
    to: '/commercials',
    icon: 'cil-industry',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavTitle',
    name: 'Ajustes',
    to: '/vehicles',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Perfil',
    to: '/setting',
    icon: 'cil-settings',
    require_admin: true,
    show_admin: true,
  },
  {
    component: 'CNavItem',
    name: 'Roles',
    to: '/roles',
    icon: 'cil-settings',
    require_admin: true,
    show_admin: true,
  },
  /*{
    component: 'CNavGroup',
    name: 'Configuración',
    to: '/setting',
    icon: 'cil-settings',
    require_admin: true,
    show_admin: true,
    items: [
   
      
    ]
  }*/
]